import { Component } from '@angular/core';

import * as _ from 'lodash';

import { DialogBaseService } from '../../dialog.base.service';
import { Dialog } from '../../dialog.base';

/**
 * @ignore
 */
@Component({
  selector: 'uex-dialog-wrapper',
  templateUrl: './wrapper.component.html'
})
export class DialogWrapperComponent {
  constructor(
    private _dialogService: DialogBaseService
  ) { }

  public get dialogs(): Array<Dialog> {
    return this._dialogService.dialogs;
  }
}
